module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"Data Pivot View"}}')
  delete Component.options._Ctor
}
